import AppRouter from './AppRouter'
import Theme from './assets/styles/theme'
import Footer from './components/layout/footer'
import Header from './components/layout/header'
import styled from 'styled-components'
import ReactGA from 'react-ga4'
import { useEffect } from 'react'

// TODO Move this into environment vairable
const TRACKING_ID = 'G-PDJ3D4Y0C0'

function App() {
  useEffect(() => {
    ReactGA.initialize(TRACKING_ID)
    ReactGA.send({
      hitType: 'pageview',
      page: '/landingpage',
      title: 'Community of Guardians',
    })
  }, [])
  return (
    <Theme>
      <AppContainer>
        <Header />
        <AppRouter />
        <Footer />
      </AppContainer>
    </Theme>
  )
}

const AppContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
`

export default App
